import React from 'react';
import './Loading.css';

const Loader = ({ inline = false }) => (
  <div className={inline ? 'loader loader--inline' : 'loader'}>
    <div className="spinner" role="status" aria-label="Loading" />
  </div>
);

export default Loader;
